import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<span class=\"formatted-selection\">\n  {{this.formattedContent}}\n</span>", {
  moduleName: "select-kit/components/multi-select/format-selected-content.hbs"
});